import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SupplierOrder\UpdateSupplierOrderStatusController::__invoke
* @see app/Http/Controllers/SupplierOrder/UpdateSupplierOrderStatusController.php
* @route '/api/supplier-order/{supplier_order}/status'
*/
const UpdateSupplierOrderStatusController = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: UpdateSupplierOrderStatusController.url(args, options),
    method: 'patch',
})

UpdateSupplierOrderStatusController.definition = {
    methods: ["patch"],
    url: '/api/supplier-order/{supplier_order}/status',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\SupplierOrder\UpdateSupplierOrderStatusController::__invoke
* @see app/Http/Controllers/SupplierOrder/UpdateSupplierOrderStatusController.php
* @route '/api/supplier-order/{supplier_order}/status'
*/
UpdateSupplierOrderStatusController.url = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { supplier_order: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { supplier_order: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            supplier_order: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        supplier_order: typeof args.supplier_order === 'object'
        ? args.supplier_order.id
        : args.supplier_order,
    }

    return UpdateSupplierOrderStatusController.definition.url
            .replace('{supplier_order}', parsedArgs.supplier_order.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\UpdateSupplierOrderStatusController::__invoke
* @see app/Http/Controllers/SupplierOrder/UpdateSupplierOrderStatusController.php
* @route '/api/supplier-order/{supplier_order}/status'
*/
UpdateSupplierOrderStatusController.patch = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: UpdateSupplierOrderStatusController.url(args, options),
    method: 'patch',
})

export default UpdateSupplierOrderStatusController